<template>
  <b-container v-if="createAny('users')" fluid>
    <!-- TItle bar -->
    <div class="title-bar">
      <h1>{{ $t("labels.check_hours") }}</h1>
    </div>
    <!-- Filter bar -->
    <b-row class="filter-bar">
      <b-col md="4" xl>
        <b-form-group :label="$t('labels.from')">
          <b-form-input type="week" v-model="startw" />
        </b-form-group>
      </b-col>
      <b-col md="4" xl>
        <b-form-group :label="$t('labels.to')">
          <b-form-input type="week" v-model="endw" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="filter-bar">
      <b-col cols="4">
        <b-form-checkbox
          v-model="show_all"
          name="checkbox-1"
          value="1"
          unchecked-value="0"
          >{{ $t("labels.showclosedhours") }}</b-form-checkbox
        >

        <b-form-checkbox
          v-model="show_absent"
          name="checkbox-1"
          value="1"
          unchecked-value="0"
          >{{ $t("labels.showabsentweeks") }}</b-form-checkbox
        >
      </b-col>
      <b-col cols="1" align-self="end">
        <label>{{ $t("titles.projects") }}</label>
      </b-col>
      <b-col cols="6">
        <v-select
          :options="thisweeksprojects()"
          :reduce="(c) => c.id"
          label="label"
          class="contactpersoon"
          v-model="filterproject"
        />
      </b-col>
    </b-row>
    <b-table
      sort-icon-left
      :items="thisweekscontracts()"
      :filter="filterproject"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :current-page="currentPage"
      :per-page="perPage"
      :filter-function="filterTable"
    >
      <template #cell(hours)="row">
        <table>
          <td v-for="(item, index) in row.item.dates" :key="index">
            {{ dateToNL(item) }}
            <div v-if="searchHours(item, row.item.hours)">
              {{ searchHours(item, row.item.hours).hours }}
              <font-awesome-icon
                v-if="searchHours(item, row.item.hours).agree_company == null"
                color="red"
                icon="signature"
              />
              <font-awesome-icon v-else color="green" icon="signature" />
            </div>
            <div v-else>
              <font-awesome-icon color="red" icon="times" />
            </div>
          </td>
        </table>
      </template>
      <template #cell(actions)="row">
        <b-dropdown
          id="dropdown-dropup"
          dropup
          :text="$t('buttons.doaction')"
          variant="primary"
        >
          <b-dropdown-item
            v-if="row.item.isabsent"
            @click="setPresent(row.item)"
          >
            <font-awesome-icon icon="eye" /> {{ $t("labels.setpresent") }}
          </b-dropdown-item>
          <b-dropdown-item v-else @click="setAbsent(row.item)">
            <font-awesome-icon icon="eye-slash" /> {{ $t("labels.setabsent") }}
          </b-dropdown-item>
          <b-dropdown-item
            @click="
              showUserHours(
                row.item.contract_id,
                parseInt(row.item.week.substring(1, 4))
              )
            "
            :title="$t('labels.showhours')"
          >
            <font-awesome-icon icon="clipboard-list" />
            {{ $t("labels.showhours") }}
            {{ parseInt(row.item.week.substring(1, 4)) }}
          </b-dropdown-item>
          <b-dropdown-item @click="resendCheckHours(row.item)">
            <font-awesome-icon icon="envelope" />
            {{ $t("buttons.sendrequest") }}
            {{ $t("labels.check_hours").toLowerCase() }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
      <template #cell(lastname)="row" @click.native.capture="show_user()">
        <p v-html="userinfo(row)" />
      </template>
      <template #cell(company_id)="row">
        <p v-html="companyinfo(row)" />
      </template>
      <template #cell(sign_id)="row">
        <p v-html="signinfo(row)" />
      </template>
      <template #cell(smszzpr)="row">
        <a
          href="javascript:;"
          class="action-item"
          @click="sendSMSUser(row.item)"
          :title="$t('labels.sendsms')"
        >
          <font-awesome-icon size="2x" icon="sms" />
        </a>
      </template>
      <template #cell(smssign)="row">
        <a
          href="javascript:;"
          class="action-item"
          @click="sendSMSSigner(row.item)"
          :title="$t('labels.sendsms')"
        >
          <font-awesome-icon size="2x" icon="sms" />
        </a>
      </template>
      <template #cell(totalHours)="row">
        {{ row.item.week }}
        <p
          v-html="gethoursinfo(row)"
          @click="
            showUserHours(
              row.item.contract_id,
              parseInt(row.item.week.substring(1, 4))
            )
          "
        />
        <p v-if="current_user.id == 1">{{ row.item.contract_id }}</p>
      </template>
      <template #cell(signed)="row">
        <font-awesome-icon
          v-if="!row.item.closed"
          color="red"
          icon="times"
          :title="$t('labels.weeknotclosed')"
        />
        <div v-else>
          <font-awesome-icon
            v-if="row.item.signed"
            color="green"
            icon="signature"
            :title="$t('labels.hoursstatuschecked')"
          />
          <font-awesome-icon
            v-else
            color="red"
            icon="signature"
            :title="$t('labels.hourswaiting')"
          />
        </div>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
    ></b-pagination>
    <BSAbsentModal
      :contract_id="selected_contractID"
      :weeknumber="selected_week"
      :yearnumber="selected_year"
    />
  </b-container>
</template>
<script>
import axios from "axios";
import { mapActions, mapState, mapGetters } from "vuex";
import send_sms_modal from "./modals/SendSMSModal";
import BSAbsentModal from "./modals/BSAbsentModal.vue";

export default {
  name: "HoursOverview",
  data() {
    return {
      startw: null,
      endw: null,
      hashours: "yes",
      show_all: "0",
      show_absent: "0",
      allhours: [],
      sortBy: "lastname",
      sortDesc: false,
      sortDirection: "desc",
      currentPage: 1,
      perPage: 20,
      selected_contractID: 0,
      selected_week: 0,
      selected_year: 0,
      totalRowsNow: 500,
      totalRows: 0,
      filterproject: 100000,
    };
  },
  mounted() {
    let now = new Date(
      new Date(new Date().getTime() - +7 * 24 * 60 * 60 * 1000)
    );
    let sweek = this.getWeekNumber(now);
    // now.setDate(now.getDate() - 7);
    sweek = this.getWeekNumber(now);
    // console.log("S", now.getDay(), sweek)
    // if(now.getDay()==1){
    //   sweek[1]++
    //   this.startw = parseInt(sweek[1] - 1) < 10 ? sweek[0] + "-W0" + (sweek[1]) : sweek[0] + "-W" + (sweek[1] - 1)
    //   this.endw = parseInt(sweek[1]) < 10 ? sweek[0] + "-W0" + sweek[1] : sweek[0] + "-W" + sweek[1]
    // } else{
    console.log(sweek);
    let week = parseInt(sweek[1]);
    week--;

    this.startw =
      week < 10
        ? sweek[0] + "-W0" + week - 1
        : sweek[0].toString() + "-W" + week.toString();
    this.endw =
      parseInt(sweek[1]) < 10
        ? sweek[0] + "-W0" + sweek[1]
        : sweek[0] + "-W" + sweek[1];
    // this.startw = "2025-W01"
    // this.endw = "2025-W03"
    // }
    console.log("mounted", this.startw, this.endw);
  },
  computed: {
    ...mapState([
      "contracts",
      "branches",
      "avatars",
      "planning",
      "workfields",
      "tags",
      "current_user",
      "showBlacklist",
      "hours",
      "urenbonnen",
      "invoiceextra",
    ]),
    ...mapGetters([
      "branche_by_id",
      "project_by_id",
      "company_by_id",
      "user_by_id",
      "user_photo_by_id",
      "activebranches",
      "username_by_id",
      "confirm_modal",
      "owners",
      "find_last_planning_user",
      "contract_by_id",
      "server_url",
      "createAny",
    ]),
    static_weekdays() {
      return this.allhours;
    },
    fields() {
      if (this.smsEnabled()) {
        return [
          { key: "week", sortable: true, sortDirection: "desc" },
          // {key:'startdate'},
          // {key:'enddate'},
          {
            key: "lastname",
            label: this.$i18n.t("labels.name"),
            sortable: true,
            sortDirection: "desc",
          },
          { key: "smszzpr", label: "" },
          {
            key: "company_id",
            label: this.$i18n.t("labels.client"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "sign_id",
            label: this.$i18n.t("labels.authorizedsignatory"),
            sortable: true,
            sortDirection: "desc",
          },
          { key: "smssign", label: "" },
          { key: "totalHours" },
          { key: "signed", sortable: true, sortDirection: "desc" },
          { key: "actions", label: this.$i18n.t("labels.actions") },
        ];
      } else {
        return [
          { key: "week", sortable: true, sortDirection: "desc" },
          {
            key: "lastname",
            label: this.$i18n.t("labels.name"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "company_id",
            label: this.$i18n.t("labels.client"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "sign_id",
            label: this.$i18n.t("labels.authorizedsignatory"),
            sortable: true,
            sortDirection: "desc",
          },
          { key: "totalHours" },
          { key: "signed" },
          { key: "actions", label: this.$i18n.t("labels.actions") },
        ];
      }
    },
  },
  methods: {
    async resendCheckHours(row) {
      console.log("resned", row);
      let realplanning = this.planning_by_id(
        this.contract_by_id(row.contract_id).planning_id
      );
      let week = parseInt(row.week.substring(1));
      console.log("WEEEEEEEEEEEEEEEEEK", week);
      console.log(">>>>>>>>>>>>>>>MAIL", realplanning);
      if (realplanning.mailurencontact == "yes") {
        let email = this.user_by_id(realplanning.sign_id).email;
        let name = this.username_by_id(realplanning.sign_id);
        let message = {};
        message.email = email;
        message.name = name;
        message.user_id = realplanning.sign_id;
        message.message = this.settings.hoursfilledmessage.replaceAll(
          /\[zzper\]/gi,
          this.username_by_id(row.user_id)
        );
        message.message = message.message.replaceAll(/\[week\]/gi, week);
        message.message = message.message.replaceAll(
          /\[project_name\]/gi,
          realplanning.project_name
        );
        message.message = message.message.replaceAll(
          /\[signer\]/gi,
          this.user_by_id(realplanning.sign_id).firstname
        );

        message.message = message.message.replaceAll(
          /\[hoursoverview\]/gi,
          this.hoursoverviewHTML(row.contract_id, week + "-" + row.year)
        );

        message.subject = this.settings.hoursfilledsubject.replaceAll(
          /\[zzper\]/gi,
          this.username_by_id(row.user_id)
        );
        message.subject = message.subject.replaceAll(/\[week\]/gi, week);
        message.subject = message.subject.replaceAll(
          /\[project_name\]/gi,
          realplanning.project_name
        );
        message.subject = message.subject.replaceAll(
          /\[signer\]/gi,
          this.user_by_id(realplanning.sign_id).firstname
        );
        message.contract_id = row.contract_id;
        message.week = week;
        message.year = row.year;
        message.maindocuments = [];
        // let emailnotification = parseInt(this.user_by_id(realplanning.sign_id).mail)==1 && this.realplanning.hourregistration=='app'
        let emailnotification =
          realplanning.mailurencontact == "yes" &&
          parseInt(this.user_by_id(realplanning.sign_id).mail) == 1 &&
          realplanning.hourregistration == "app";
        if (realplanning.copy_id) {
          message.cc = [this.user_by_id(realplanning.copy_id).email];
        }
        if (message.message.indexOf("rating") != -1) {
          let obj = {};
          obj.user_id = row.user_id;
          obj.reviewer_id = realplanning.sign_id;
          obj.contract_id = row.contract_id;
          obj.request_id = this.settings.reviewquestions.id;
          await axios
            .post("/api/reviewsend", obj)
            .then(async function (response) {
              console.log("reviewsendRESULT", response);
              if (response.status == 200) {
                let reviewsenddata = response.data;
                await axios
                  .post("/api/get_review_user_hash/", reviewsenddata)
                  .then(async (response) => {
                    console.log("succes", response);
                    let encrypted = response.data;
                    message.message = message.message.replaceAll(
                      /\[rating\]/gi,
                      'Klik hier om het werk te beoordelen <br><br><br><a style="text-decoration: none;background-color: #FC8007; border-color: #FC8007;color:#fff;text-align: center; vertical-align: middle;	font-size: 1rem; line-height: 1.5; padding: 0.75rem 1.5rem; border-radius: 2rem;cursor: pointer;height:24px;width:240px;" href="' +
                        encrypted +
                        '">beoordelen</a> '
                    );
                  });
              }
            });
        }
        if (message.message.indexOf("confirmurl") != -1) {
          let obj = {};
          obj.contract_id = row.contract_id;
          obj.week = week;
          obj.year = row.year;
          await axios
            .post("/api/get_confirm_hash/", obj)
            .then(async (response) => {
              // console.log('succes',response)
              let encrypted = response.data;
              message.message = message.message.replaceAll(
                /\[confirmurl\]/gi,
                'Klik hier voor akkoord <br><a style="text-decoration: none;background-color: #FC8007; border-color: #FC8007;color:#fff;text-align: center; vertical-align: middle;	font-size: 1rem; line-height: 1.5; padding: 0.75rem 1.5rem; border-radius: 2rem;cursor: pointer;height:24px;width:240px;" href="' +
                  encrypted +
                  '">Akkoord</a> '
              );
              if (emailnotification) {
                try {
                  axios.post("/api/contact_user", message).then((response) => {
                    console.log("succes", response);
                  });
                } catch (err) {
                  console.log(err);
                }
              }
            });
        } else {
          if (emailnotification) {
            try {
              axios.post("/api/contact_user", message).then((response) => {
                console.log("succes", response);
              });
            } catch (err) {
              console.log(err);
            }
          }
        }
        let inappnotification =
          parseInt(row.user_by_id(realplanning.sign_id).inapp) == 1;
        if (inappnotification) {
          if (this.settings.PMHistory) {
            this.add_pm({
              id: 0,
              from: row.user_id,
              to: realplanning.sign_id,
              message: message,
            });
          }
          try {
            axios.post("/api/notify", message).then((response) => {
              console.log("succes", response);
            });
          } catch (err) {
            console.log(err);
          }
        }
      }
    },
    thisweekscontracts() {
      let values = [];
      if (this.startw) {
        let startyear = this.startw.substring(0, 4);
        let startweek = parseInt(this.startw.substring(6));
        let endyear = this.endw.substring(0, 4);
        let endweek = parseInt(this.endw.substring(6));

        var startdate = new Date(
          this.getWeekOfYear(parseInt(startyear), startweek)[0]
        );
        var enddate = new Date(
          this.getWeekOfYear(parseInt(endyear), endweek)[6]
        );
        // find userplanning in date
        let ups = this.planning.filter((up) => {
          let projstartdate = new Date(up.startdate);
          let projenddate = new Date(up.enddate);
          projstartdate.setHours(0, 0, 0, 0);
          projenddate.setHours(0, 0, 0, 0);
          startdate.setHours(0, 0, 0, 0);
          enddate.setHours(0, 0, 0, 0);
          if (projstartdate <= enddate && projenddate >= startdate) {
            return true;
          }
        });
        let planning_ids = [...new Set(ups.map((item) => item.id))];
        var loopstart = startdate;
        this.contracts
          .filter((c) => planning_ids.indexOf(c.planning_id) != -1)
          .forEach((c) => {
            if (this.user_by_id(c.user_id) != null) {
              let userplan = this.userplanning(c.user_id).filter(
                (p) => p.project_id == c.project_id
              );
              let chours = this.has_hours(c.id);

              for (var p = 0; p < userplan.length; p++) {
                loopstart = startdate;
                // console.log(loopstart, enddate)
                while (loopstart <= enddate) {
                  var loopend = new Date(
                    loopstart.getTime() + 6 * 24 * 60 * 60 * 1000
                  );
                  let row = {};
                  let betweendates = false;
                  let sweek = this.getWeekNumber(loopstart);
                  let project = this.project_by_id(c.project_id);
                  if (project) {
                    row.realweek = parseInt(sweek[1]);
                    row.week =
                      row.realweek < 10 ? "W0" + sweek[1] : "W" + sweek[1];
                    row.year = parseInt(sweek[0]);
                    row.startdate = loopstart;
                    row.enddate = loopend;
                    row.project = userplan[p].project_name;
                    row.user_id = userplan[p].user_id;
                    row.project_id = c.project_id;
                    row.lastname = this.user_by_id(
                      userplan[p].user_id
                    ).lastname;
                    row.sign_id = userplan[p].sign_id;
                    row.signed_zzpr = c.signed_zzpr;
                    row.signed_company = c.signed_company;
                    let projstartdate = new Date(userplan[p].startdate);
                    let projenddate = new Date(userplan[p].enddate);
                    projstartdate.setHours(0, 0, 0, 0);
                    projenddate.setHours(0, 0, 0, 0);
                    loopend.setHours(0, 0, 0, 0);
                    loopstart.setHours(0, 0, 0, 0);
                    if (projstartdate <= loopend && projenddate >= loopstart) {
                      betweendates = true;
                    }
                    // if(c.user_id==1241){
                    //   console.log(sweek)
                    //   console.log(projstartdate)
                    //   console.log(loopend)
                    //   console.log(projenddate)
                    //   console.log(loopstart)
                    //   console.log(betweendates)

                    // }

                    let company = this.company_by_id(project.company_id);
                    row.company_id = company.id;
                    row.contract_id = c.id;
                    row.hours = [];
                    const wd = this.getWeekDates(row.realweek, row.year);
                    chours = this.hours.filter(
                      (ahour) => ahour.contract_id == c.id
                    );
                    chours.forEach((element) => {
                      if (row.user_id == 17 && c.id == 805) {
                        console.log(">>>", element);
                      }
                      if (wd.includes(element.workdate)) {
                        row.hours.push(element);
                      }
                    });
                    row.closed =
                      row.hours.filter(
                        (ahour) =>
                          ahour.close_hours == 1 &&
                          wd.filter((adate) => adate == ahour.workdate).length >
                            0
                      ).length > 0;

                    row.signed =
                      row.hours.filter(
                        (ahour) =>
                          ahour.agree_company == 1 &&
                          wd.filter((adate) => adate == ahour.workdate).length >
                            0
                      ).length > 0;
                  }
                  let absent = this.invoiceextra.filter(
                    (i) =>
                      i.contract_id == row.contract_id &&
                      i.week == sweek[1] &&
                      i.year == row.year
                  );
                  let isabsent = absent.length > 0 && absent[0].absent == 1;
                  row.isabsent = isabsent;
                  if (this.show_absent == "1") {
                    isabsent = false;
                  }
                  if (betweendates && !isabsent) {
                    if (this.show_all == "1" || !row.signed) {
                      values.push(row);
                    }
                  }
                  loopstart = new Date(
                    loopstart.getTime() + 7 * 26 * 60 * 60 * 1000
                  );
                }
              }
            }
          });
      }
      this.totalRows = values.length;
      return values;
    },
    thisweeksprojects() {
      let values = [{ id: 100000, label: this.$t("buttons.showall") }];
      if (this.startw) {
        let startyear = this.startw.substring(0, 4);
        let startweek = parseInt(this.startw.substring(6));
        let endyear = this.endw.substring(0, 4);
        let endweek = parseInt(this.endw.substring(6));

        var startdate = new Date(
          this.getWeekOfYear(parseInt(startyear), startweek)[0]
        );
        var enddate = new Date(
          this.getWeekOfYear(parseInt(endyear), endweek)[6]
        );
        // find userplanning in date
        let ups = this.planning.filter((up) => {
          let projstartdate = new Date(up.startdate);
          let projenddate = new Date(up.enddate);
          projstartdate.setHours(0, 0, 0, 0);
          projenddate.setHours(0, 0, 0, 0);
          startdate.setHours(0, 0, 0, 0);
          enddate.setHours(0, 0, 0, 0);
          if (projstartdate <= enddate && projenddate >= startdate) {
            return true;
          }
        });
        let planning_ids = [...new Set(ups.map((item) => item.id))];
        var loopstart = startdate;
        this.contracts
          .filter((c) => planning_ids.indexOf(c.planning_id) != -1)
          .forEach((c) => {
            if (this.user_by_id(c.user_id) != null) {
              let userplan = this.userplanning(c.user_id).filter(
                (p) => p.project_id == c.project_id
              );

              for (var p = 0; p < userplan.length; p++) {
                loopstart = startdate;
                // console.log(loopstart, enddate)
                while (loopstart <= enddate) {
                  var loopend = new Date(
                    loopstart.getTime() + 6 * 24 * 60 * 60 * 1000
                  );
                  let row = {};
                  let betweendates = false;
                  let sweek = this.getWeekNumber(loopstart);
                  let project = this.project_by_id(c.project_id);
                  if (project) {
                    row.id = c.project_id;
                    row.label = this.project_by_id(c.project_id).title;
                    let projstartdate = new Date(userplan[p].startdate);
                    let projenddate = new Date(userplan[p].enddate);
                    projstartdate.setHours(0, 0, 0, 0);
                    projenddate.setHours(0, 0, 0, 0);
                    loopend.setHours(0, 0, 0, 0);
                    loopstart.setHours(0, 0, 0, 0);
                    if (projstartdate <= loopend && projenddate >= loopstart) {
                      betweendates = true;
                    }

                    let absent = this.invoiceextra.filter(
                      (i) =>
                        i.contract_id == row.contract_id &&
                        i.week == sweek[1] &&
                        i.year == row.year
                    );
                    let isabsent = absent.length > 0 && absent[0].absent == 1;
                    if (this.show_absent == "1") {
                      isabsent = false;
                    }
                    if (betweendates && !isabsent) {
                      if (this.show_all == "1" || !row.signed) {
                        if (values.filter((r) => r.id == row.id).length == 0) {
                          values.push(row);
                        }
                      }
                    }
                    loopstart = new Date(
                      loopstart.getTime() + 7 * 26 * 60 * 60 * 1000
                    );
                  }
                }
              }
            }
          });
      }
      return values;
    },
    userinfo(row) {
      let res = "";
      if (this.user_by_id(row.item.user_id)) {
        res =
          '<a href="/#/user/' +
          row.item.user_id +
          '" :style="{ cursor: \'pointer\'}" class="link-item"> ' +
          this.username_by_id(row.item.user_id) +
          "</a><br/>";
      }
      if (
        this.user_by_id(row.item.user_id) &&
        this.user_by_id(row.item.user_id).mobile
      ) {
        res +=
          '<a href="tel:' +
          this.user_by_id(row.item.user_id).mobile +
          '" class="link-item">' +
          this.user_by_id(row.item.user_id).mobile +
          "</a>";
      }
      return res;
    },
    companyinfo(row) {
      return (
        '<a href="/#/company/' +
        row.item.company_id +
        '" :style="{ cursor: \'pointer\'}" class="link-item"> ' +
        this.company_by_id(row.item.company_id).company_name +
        "</a><br/>" +
        row.item.project +
        "<br>"
      );
    },
    signinfo(row) {
      let res = "";
      if (this.user_by_id(row.item.sign_id)) {
        res =
          '<a href="/#/user/' +
          row.item.sign_id +
          '" :style="{ cursor: \'pointer\'}" class="link-item"> ' +
          this.username_by_id(row.item.sign_id) +
          "</a><br/>";
      }
      if (
        this.user_by_id(row.item.sign_id) &&
        this.user_by_id(row.item.sign_id).mobile
      ) {
        res +=
          '<a href="tel:' +
          this.user_by_id(row.item.sign_id).mobile +
          '" class="link-item">' +
          this.user_by_id(row.item.sign_id).mobile +
          "</a>";
      }
      return res;
    },
    filterTable(row) {
      console.log(row);
      if (
        this.filterproject == 100000 ||
        row.project_id == this.filterproject
      ) {
        return true;
      } else {
        return false;
      }
    },
    sendSMSUser(row) {
      let sms =
        "Dag " +
        this.user_by_id(row.user_id).firstname +
        ", mag ik je vragen om de uren van week " +
        row.week +
        " van project " +
        row.project +
        " te vullen? Alvast bedankt. M.v.gr. ZZPR.nl";
      this.$modal.hide("send_sms_modal");
      this.$modal.show(
        send_sms_modal,
        {
          message: sms,
          user_id: row.user_id,
        },
        {
          name: "send_sms_modal",
          draggable: ".popup-header",
          height: "auto",
          width: "600px",
        }
      );
      this.$emit("close");
    },
    sendSMSSigner(row) {
      let sms =
        "Dag " +
        this.user_by_id(row.sign_id).firstname +
        ", mag ik je vragen om de uren van " +
        this.username_by_id(row.user_id) +
        " in week " +
        row.week +
        "  te controleren en daarna te accorderen? Alvast bedankt. M.v.gr. ZZPR.nl";
      this.$modal.hide("send_sms_modal");
      this.$modal.show(
        send_sms_modal,
        {
          message: sms,
          user_id: row.sign_id,
        },
        {
          name: "send_sms_modal",
          draggable: ".popup-header",
          height: "auto",
          width: "600px",
        }
      );
      this.$emit("close");
    },
    ...mapActions(["delete_user", "save_user"]),
    usersort(a, b) {
      if (a.user_id < b.user_id) {
        return -1;
      }
      if (a.user_id > b.user_id) {
        return 1;
      }
      return 0;
    },
    userplanning(user_id) {
      return this.planning.filter((aplanning) => aplanning.user_id == user_id);
    },
    has_hours(contract_id) {
      return this.hours.filter(
        (ahour) =>
          ahour.contract_id == contract_id &&
          this.static_weekdays.includes(ahour.workdate)
      );
    },
    doHours(hours) {
      if (hours) {
        return hours.length;
      } else {
        return 0;
      }
    },
    searchHours(nameKey, myArray) {
      return myArray.filter((element) => element.workdate == nameKey);
    },
    gethoursinfo(row) {
      if (row.item.user_id == 1291) {
        console.log("jeroen", row.item.year, row.item.realweek);
      }
      var totalnormal = 0;
      var declaraties = new Object();
      let contract = this.contract_by_id(row.item.contract_id);
      let userplanning = this.planning_by_id(
        this.contract_by_id(row.item.contract_id).planning_id
      );
      let contractstart = new Date(userplanning.startdate);
      let contractend = new Date(row.enddate);
      let startmonday = new Date(
        this.getWeekOfYear(parseInt(row.item.year), row.item.realweek)[0]
      );
      var loop = new Date(startmonday);
      let enddate = new Date(startmonday);
      enddate.setDate(startmonday.getDate() + 6);
      let alldates = [];
      if (row.item.user_id == 1291) {
        console.log("hoursinfo", loop, enddate, row.item.contract_id);
      }
      while (loop < enddate) {
        let thisday = this.dateToYYYYMMDD(loop);
        if (
          loop.setHours(0, 0, 0) < contractstart.setHours(0, 0, 0) ||
          loop.setHours(0, 0, 0) > contractend.setHours(0, 0, 0)
        ) {
          alldates.push("0");
        } else {
          alldates.push(thisday);
        }
        var newDate = loop.setDate(loop.getDate() + 1);
        loop = new Date(newDate);
      }
      if (row.item.user_id == 1291) {
        console.log("alldates", alldates);
      }
      if (alldates) {
        for (var adate of alldates) {
          for (var ahour of this.hours) {
            if (
              ahour.contract_id == contract.id &&
              ahour.workdate == adate &&
              ahour.user_id == contract.user_id
            ) {
              totalnormal += parseFloat(ahour.hours);
              if (row.item.user_id == 1291) {
                console.log("jeroen", ahour, adate);
              }
              for (const onregel of contract.onregelmatig) {
                let declaratie_cat = this.declaratie_by_id(
                  onregel.declaratie_id
                );
                if (
                  ahour[declaratie_cat.name] != undefined &&
                  declaratie_cat.active == 1
                ) {
                  if (declaratie_cat.name in declaraties) {
                    if (
                      !isNaN(parseFloat(ahour[declaratie_cat.name])) &&
                      ahour[declaratie_cat.name] != null
                    ) {
                      declaraties[declaratie_cat.name] += parseFloat(
                        ahour[declaratie_cat.name]
                      );
                    }
                  } else {
                    if (
                      !isNaN(parseFloat(ahour[declaratie_cat.name])) &&
                      ahour[declaratie_cat.name] != null
                    ) {
                      declaraties[declaratie_cat.name] = parseFloat(
                        ahour[declaratie_cat.name]
                      );
                    }
                  }
                }
              }
            }
          }
        }
      }
      var retstring =
        this.$i18n.t("titles.project_hours") +
        "<strong> " +
        totalnormal +
        "</strong><br/>";
      for (var k in declaraties) {
        retstring +=
          k + "<strong> " + declaraties[k].toFixed(2) + "</strong><br/>";
      }
      return retstring;
    },
    thisweekdays() {
      if (this.startw) {
        let startyear = this.startw.substring(0, 4);
        let startweek = parseInt(this.startw.substring(6));

        let endweek = parseInt(this.endw.substring(6));
        let d = this.getWeekOfYear(parseInt(startyear), parseInt(startweek));
        while (startweek < endweek) {
          startweek++;
          d = d.concat(
            this.getWeekOfYear(parseInt(startyear), parseInt(startweek))
          );
        }
        return d;
      }
      return null;
    },
    setAbsent(item) {
      this.selected_contractID = item.contract_id;
      this.selected_week = item.realweek;
      this.selected_year = item.year;
      this.$bvModal.show("BSAbsentModalID");
    },
    setPresent(item) {
      try {
        axios
          .post("/api/set_week_absent", {
            contract_id: item.contract_id,
            week: item.realweek,
            year: item.year,
            absent: 0,
            reason: "",
          })
          .then(async () => {
            this.$store.dispatch("get_invoiceextra");
          });
      } catch (err) {
        console.log(err);
      }
    },
  },
  components: { BSAbsentModal },
  watch: {
    startw: function () {
      this.allhours = this.thisweekdays();
    },
    endw: function () {
      this.allhours = this.thisweekdays();
    },
  },
};
</script>
